export default "__VITE_ASSET__i_P$1R9f__"